import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { FuseDashboardComponent } from './dashboard.component';
import { SharedModule } from '../../../core/modules/shared.module';
import { DashboardService } from './dashboard.service';
import { FuseWidgetModule } from '../../../core/components/widget/widget.module';
import { NgxChartsModule } from '@swimlane/ngx-charts';
import { MiniMapaModule } from '../../components/mini-mapa/mini-mapa.module';
import { StatsModule } from '../stats/stats.module';
import { SelectorModule } from '../selector/selector.module';

const routes: Routes = [
    {
        path     : 'dashboard',
        component: FuseDashboardComponent,
    },
    {
        path     : 'dashboard/:activoSeleccionado',
        component: FuseDashboardComponent
    }
];

@NgModule({
    imports     : [
        SharedModule,
        RouterModule.forChild(routes),
        FuseWidgetModule,
        NgxChartsModule,
        MiniMapaModule,
        SelectorModule,
        StatsModule
    ],
    declarations: [
        FuseDashboardComponent
    ],
    providers   : [
        DashboardService
    ]
})
export class FuseDashboardModule
{
}



// WEBPACK FOOTER //
// ./src/app/main/content/dashboard/dashboard.module.ts